import { render, staticRenderFns } from "./ModifyCorporateStep2.vue?vue&type=template&id=5e940369&scoped=true&"
import script from "./ModifyCorporateStep2.vue?vue&type=script&lang=js&"
export * from "./ModifyCorporateStep2.vue?vue&type=script&lang=js&"
import style0 from "./ModifyCorporateStep2.vue?vue&type=style&index=0&id=5e940369&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e940369",
  null
  
)

export default component.exports